<template>
  <v-dialog v-if="user" :value="settingsDialogVisible" persistent width="500">
    <v-card>
      <v-card-title class="headline">
        {{ $t('settings.title') }}
        <v-spacer />
        <v-btn
          class="float-right"
          icon
          @click="changeSettingsDialogVisibility(false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <rooms />

        <languages />

        <visit-types />

        <h6 class="text-h6 my-2">
          {{ $t('settings.user') }} {{ user.firstname }} {{ user.surname }}
        </h6>
        <div class="text-center">
          <v-btn
            block
            text
            outlined
            color="primary"
            class="mb-1"
            @click="changeCookieSettings"
          >
            <v-icon left>
              mdi-cookie
            </v-icon>
            {{ $t('settings.cookies') }}
          </v-btn>

          <v-btn block text outlined color="primary" @click="logout">
            <v-icon left>
              mdi-logout
            </v-icon>
            {{ $t('layout.logout') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import navigateMixin from '../../mixins/navigate'
import Rooms from './rooms'
import Languages from './languages'
import VisitTypes from './visit-types'

export default {
  mixins: [navigateMixin],
  components: {
    Rooms,
    Languages,
    VisitTypes,
  },
  data() {
    return {
      savingSettings: false,
    }
  },

  computed: {
    ...mapState('common', ['settingsDialogVisible']),
    ...mapState('auth', ['user']),
  },

  methods: {
    ...mapMutations('common', ['changeSettingsDialogVisibility']),
    changeCookieSettings() {
      cc.showSettings()
    },
  },
}
</script>
